import moment from 'moment';

import {pluralize} from 'common/util/string';

// thresholds for units in seconds
const HOURS = 60 * 60;
const DAYS = HOURS * 24;
const MONTHS = DAYS * 30;
const YEARS = DAYS * 365;

export function getLastViewedStr(lastViewedUtcSeconds: number): string {
  const secondsDiff = new Date().getTime() / 1000 - lastViewedUtcSeconds;
  if (secondsDiff >= YEARS) {
    const num = Math.floor(secondsDiff / YEARS);
    return `> ${num} ${pluralize(`year`, num)} ago`;
  } else if (secondsDiff >= MONTHS) {
    const num = Math.min(Math.floor(secondsDiff / MONTHS), 11);
    return `${num} ${pluralize(`month`, num)} ago`;
  } else if (secondsDiff >= DAYS) {
    const num = Math.floor(secondsDiff / DAYS);
    return `${num} ${pluralize(`day`, num)} ago`;
  }
  const num = Math.floor(secondsDiff / HOURS);
  if (num < 1) {
    return `< 1 hour ago`;
  }
  return `${num} ${pluralize(`hour`, num)} ago`;
}

export function formatDate(date: string, format: string) {
  return moment.utc(date).local().format(format);
}
